import styled from 'styled-components';

interface IWrapperProps {
  active?: boolean;
}

export const SWrapper = styled.div<IWrapperProps>`
  padding-bottom: 10px;
  display: flex;
  font-size: 17.5px;
  color: ${({ theme }) => theme.colors.secondaryText};

  ${({ active, theme }) =>
    active &&
    `
      color: ${theme.colors.primaryText}`}
`;

export const STitle = styled.div`
  width: 100%;
`;

export const SIcon = styled.i`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.icon};
`;
